// dto/pre-season-inspection.dto.ts
import { Transform, Type } from 'class-transformer'
import {
  ArrayMinSize,
  IsArray,
  IsBoolean,
  IsInt,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
  ValidateIf,
  ValidateNested,
} from 'class-validator'
import { SaveRestrictedLotDto } from './save-restricted-lot.dto'

export class SavePreSeasonInspectionDto {
  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @IsInt()
  @IsPositive()
  id?: number

  @Transform(({ value }) => value === 'true' || value === true)
  @IsBoolean()
  isUsedForBALastYear!: boolean

  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @IsInt()
  @IsPositive()
  waterSource?: number

  @IsBoolean()
  @Transform(({ value }) => value === 'true' || value === true)
  hasContaminationEvidence!: boolean

  @ValidateIf((o) => o.hasContaminationEvidence === true)
  @IsString()
  contaminationComment?: string

  @IsBoolean()
  @Transform(({ value }) => value === 'true' || value === true)
  isAdjacentLandFreeOfRisks!: boolean

  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @IsInt()
  @IsPositive()
  wildlifeEvidence?: number

  @IsBoolean()
  @Transform(({ value }) => value === 'true' || value === true)
  hasRestrictedLots!: boolean

  @ValidateIf((o) => o.hasRestrictedLots)
  @IsArray()
  @ArrayMinSize(1)
  @ValidateNested({ each: true })
  @Type(() => SaveRestrictedLotDto)
  restrictedLots?: SaveRestrictedLotDto[]

  @IsOptional()
  @IsString()
  note?: string
}
